var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarrantywiseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 731 111.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 55.9,
    x2: 498,
    y2: 55.9,
    gradientTransform: "translate(0 114) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee3d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ee4123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f04e22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f26321"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5811f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5841f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.6,7.4c1.8,5.6-1.3,11.8-6.9,13.6-5.6,1.8-11.8-1.3-13.6-6.9s1.3-11.8,6.9-13.6c5.6-1.8,11.8,1.3,13.6,6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.3,28.3l-19.1,59.8h-16.8l-9.6-32-9.6,32h-16.8l-19.1-59.8h19.1l8.6,32.1,9.3-32.1h16.8l9.3,32.1,8.6-32.1h19.3ZM591.2,28.3h17.9v59.8h-17.9V28.3ZM665.7,70.2c0,13.8-12,19.6-24.9,19.6s-21.1-4.6-25.7-14.2l15.6-8.9c1.6,4.6,4.9,7.1,10.2,7.1s6.5-1.3,6.5-3.7c0-6.6-29.4-3.1-29.4-23.8s11-19.6,23.5-19.6,18.3,4.3,23.3,12.8l-15.3,8.3c-1.7-3.1-4.1-5.3-8-5.3s-5,1.2-5,3.4c-.2,6.7,29.2,2.2,29.2,24.3ZM702.2,73.8c4.9,0,9.1-1.9,11.5-4.6l14.4,8.3c-5.9,8.1-14.7,12.3-26.1,12.3-20.5,0-33.2-13.8-33.2-31.6s12.9-31.6,31.8-31.6,30.4,13.5,30.4,31.6-.2,4.9-.7,7.2h-42.5c2.3,6.2,7.8,8.4,14.4,8.4ZM713.2,52c-1.9-6.9-7.3-9.5-12.7-9.5s-11.4,3.4-13,9.5h25.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,4.6h20l14.4,58.2L50.4,4.6h15.5l16,58.2,14.4-58.2h20l-23,83.2h-21.6l-13.6-49.1-13.5,49.1h-21.7L0,4.6ZM174.2,28.4v59.4h-17.8v-5.6c-3.9,4.5-9.7,7.3-17.7,7.3-15.6,0-28.4-13.7-28.4-31.4s12.8-31.4,28.4-31.4,13.8,2.7,17.7,7.3v-5.6s17.8,0,17.8,0ZM156.4,58.1c0-8.9-5.9-14.5-14.1-14.5s-14.1,5.6-14.1,14.5,5.9,14.5,14.1,14.5,14.1-5.6,14.1-14.5ZM219.4,27.2v20.2c-7.4-1.2-17.8,1.8-17.8,13.5v26.9h-17.8V28.4h17.8v10.6c2.4-8,10.3-11.8,17.8-11.8ZM259.8,27.2v20.2c-7.4-1.2-17.8,1.8-17.8,13.5v26.9h-17.8V28.4h17.8v10.6c2.4-8,10.3-11.8,17.8-11.8ZM323.8,28.4v59.4h-17.8v-5.6c-3.9,4.5-9.7,7.3-17.7,7.3-15.6,0-28.4-13.7-28.4-31.4s12.8-31.4,28.4-31.4,13.8,2.7,17.7,7.3v-5.6s17.8,0,17.8,0ZM305.9,58.1c0-8.9-5.9-14.5-14.1-14.5s-14.1,5.6-14.1,14.5,5.9,14.5,14.1,14.5,14.1-5.6,14.1-14.5ZM390.3,51.3v36.5h-17.8v-33.9c0-7.4-4.6-10.8-10.3-10.8s-11.1,3.8-11.1,12.2v32.4h-17.8V28.4h17.8v5.6c3.2-4.4,9.2-7.3,17-7.3,12,0,22.2,8.5,22.2,24.6ZM421.6,45.5v21c0,5.1,4.4,5.6,12.2,5.1v16.2c-23.3,2.4-30.1-4.6-30.1-21.3v-21h-9.5v-17.1h9.5v-11.3l17.8-5.3v16.6h12.2v17.1h-12.1ZM498,28.4l-20.3,57.6c-6.7,18.9-17.2,26.4-33.9,25.6v-16.7c8.3,0,12.2-2.6,14.9-9.9l-23.7-56.6h19.6l13.2,36.4,11.2-36.4h19Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantywiseLogo);
export default __webpack_public_path__ + "static/media/warrantywise-logo.a6a853464bb21f6510661fb09afa25dc.svg";
export { ForwardRef as ReactComponent };